import script from "./CamReport.vue?vue&type=script&setup=true&lang=js"
export * from "./CamReport.vue?vue&type=script&setup=true&lang=js"

import "./CamReport.vue?vue&type=style&index=0&id=16b3b657&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b3b657"]])

export default __exports__